import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LogoService } from '../services/logo.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-legal-section',
  templateUrl: './legal-section.component.html',
  styleUrls: ['./legal-section.component.scss']
})
export class LegalSectionComponent implements OnInit {

  IsOptimoney: boolean;
  CompanyLogo: any;
  Company_Name = "";
  Company_Address = "";
  Domain = "";
  Company_Email = "";
  IsMobile: boolean = false;
  constructor(public sanitizer: DomSanitizer, private logoService: LogoService,
       private router: Router
  ) { }

  goHome() {
    this.router.navigate(['/dashboard']);
  }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    }
    else {
      this.IsMobile = false;
    }
  }
  ngOnInit() {
    this.SetViewPort(window.innerWidth);
    this.Domain = sessionStorage.getItem('ihjt45h45=CompanyName')
    this.Company_Name = sessionStorage.getItem('ihjt45h45=CompanyName')
    this.Company_Email = sessionStorage.getItem('ihjt45h45=jmail')
    this.Company_Address = sessionStorage.getItem('ihjt45h45=n')
    this.logoService.getLogo().pipe(
      filter(logo => !!logo) // Waits until logo is non-null
    ).subscribe(logo => {
      let img = 'data:image/jpg;base64,' + logo
      this.CompanyLogo = this.sanitizer.bypassSecurityTrustResourceUrl(img);
    });
  }
  
}
